import * as React from "react";
import { SVGProps } from "react";
const SvgElectricity = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.158 18.238a1 1 0 0 1-.838-1.547l8.732-13.388a.75.75 0 0 1 1.366.54l-1.653 9.366h6.077a1 1 0 0 1 .816 1.578l-9.87 13.933a.75.75 0 0 1-1.335-.633l2.736-9.85H9.16l-.002.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgElectricity;
